// Minnea App Store listing (Apple app id 6794593620). Single source so the
// contribute badge and the §25.5 go-dark CTA never drift apart.
export const APP_STORE_URL = "https://apps.apple.com/app/id6794593620";
